export interface BrandingTokens {
  bg?: string
  surface?: string
  text?: string
  muted?: string
  border?: string
  primary?: string
  primary2?: string
  radius?: string
}

export const applyBranding = (tokens: BrandingTokens) => {
  const root = document.documentElement.style
  if (tokens.bg) root.setProperty('--bg', tokens.bg)
  if (tokens.surface) root.setProperty('--surface', tokens.surface)
  if (tokens.text) root.setProperty('--text', tokens.text)
  if (tokens.muted) root.setProperty('--muted', tokens.muted)
  if (tokens.border) root.setProperty('--border', tokens.border)
  if (tokens.primary) root.setProperty('--primary', tokens.primary)
  if (tokens.primary2) root.setProperty('--primary2', tokens.primary2)
  if (tokens.radius) root.setProperty('--radius', tokens.radius)
}

let systemMediaQuery: MediaQueryList | null = null
let systemListener: ((event: MediaQueryListEvent) => void) | null = null
type LegacyMediaQueryList = MediaQueryList & {
  addListener?: (listener: (event: MediaQueryListEvent) => void) => void
  removeListener?: (listener: (event: MediaQueryListEvent) => void) => void
}

const resolveSystemTheme = () => (systemMediaQuery?.matches ? 'dark' : 'light')

const addMediaListener = (mql: MediaQueryList, listener: (event: MediaQueryListEvent) => void) => {
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', listener)
    return
  }
  const legacyMql = mql as LegacyMediaQueryList
  legacyMql.addListener?.(listener)
}

const removeMediaListener = (mql: MediaQueryList, listener: (event: MediaQueryListEvent) => void) => {
  if (typeof mql.removeEventListener === 'function') {
    mql.removeEventListener('change', listener)
    return
  }
  const legacyMql = mql as LegacyMediaQueryList
  legacyMql.removeListener?.(listener)
}

export const applyThemeMode = (mode?: string) => {
  if (!mode) return

  if (mode !== 'system') {
    if (systemMediaQuery && systemListener) {
      removeMediaListener(systemMediaQuery, systemListener)
    }
    systemMediaQuery = null
    systemListener = null
    document.documentElement.dataset.theme = mode
    return
  }

  if (!('matchMedia' in window)) {
    document.documentElement.dataset.theme = 'light'
    return
  }

  if (!systemMediaQuery) {
    systemMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  }
  if (!systemListener) {
    systemListener = () => {
      document.documentElement.dataset.theme = resolveSystemTheme()
    }
    addMediaListener(systemMediaQuery, systemListener)
  }
  document.documentElement.dataset.theme = resolveSystemTheme()
}
